<template>
	<Alert type="light">
		<template #icon>
			<IconCode size="lg" />
		</template>
		<slot />
	</Alert>
</template>

<script>
import Alert from './Alert.vue'
import IconCode from '../icon/IconCode.vue'
export default {
	components: {
		Alert,
		IconCode
	}
}
</script>
